var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('light-nav',{attrs:{"active":_vm.active}}),_vm._t("default"),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }